export default ['Chrome_CEF/3.2623'];
